<template>
  <v-dialog v-model="dialog" max-width="800">
    <ValidationObserver ref="customerDocumentForm" v-slot="{ invalid, passes }">
      <form
        rel="customerDocumentForm"
        class="flex flex-wrap justify-between sm:justify-center"
        @submit.prevent="passes(submit)"
      >
        <v-card>
          <v-card-text class="pa-7">
            <v-row>
              <v-col cols="6">
                <v-row class="pb-6 pt-0 mt-0">
                  <v-col cols="6" class="py-0">
                    <div class="request-label">Typ dokladu</div>
                    <div class="request-value mt-2">
                      {{ document.type.text }}
                    </div>
                  </v-col>
                </v-row>
                <div v-if="document.type.name === 'PERSONAL_ID'" class="mt-3">
                  <v-row class="pb-6 pt-0">
                    <v-col cols="6" class="py-0">
                      <div class="request-label">Jméno</div>
                      <div class="request-value mt-2">
                        {{ document.metadata.name }}
                      </div>
                    </v-col>
                    <v-col cols="6" class="py-0">
                      <div class="request-label">Příjmení</div>
                      <div class="request-value mt-2">
                        {{ document.metadata.surname }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="pb-6 pt-0">
                    <v-col cols="6" class="py-0">
                      <div class="request-label">Datum narození</div>
                      <div class="request-value mt-2">
                        {{
                          document.metadata.birthday
                            ? $dayjs(document.metadata.birthday).format('D.M.YYYY')
                            : '-'
                        }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="pb-6 pt-0">
                    <v-col cols="12" class="py-0">
                      <div class="request-label"></div>
                      <div class="mt-2">
                        <VTextAreaWithValidation
                          v-model="statusMessage"
                          label="Důvod zamítnutí"
                          :rules="status === 'REJECTED' ? 'required' : ''"
                          outlined
                          dense
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="6">
                <v-row v-if="documentUrlBase64">
                  <v-col cols="12" class="py-0 px-5">
                    <v-img max-height="400" max-width="600" contain :src="documentUrlBase64" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pl-7 pr-7 pt-7 pb-7">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              style="color: #e53935"
              outlined
              depressed
              :disabled="accepting"
              :loading="rejecting"
              @click="status = 'REJECTED'"
            >
              Zamítnout
            </v-btn>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :disabled="rejecting"
              :loading="accepting"
              @click="status = 'CONFIRMED'"
            >
              Schválit
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import arrayBufferToBase64 from '../../utils/resource'
import VTextAreaWithValidation from '../validators/VTextAreaWithValidation'
export default {
  name: 'CustomerDocumentDialog',
  components: { VTextAreaWithValidation },
  data() {
    return {
      rejecting: false,
      accepting: false,
      dialog: false,
      document: null,
      documentBase64: null,
      status: null,
      statusMessage: null,
    }
  },
  computed: {
    documentUrlBase64() {
      if (this.documentBase64) {
        return `data:image/png;base64,${this.documentBase64}`
      }
      return null
    },
  },
  created() {
    const model = this
    this.$eventBus.$on('customerDocumentDialog', function (dialog, document) {
      model.dialog = dialog
      model.document = document
      model.status = null
      model.statusMessage = null
      model.documentBase64 = null
      model.loadDocument()
    })
  },
  methods: {
    ...mapActions({
      getArrayBuffer: 'upload/getArrayBuffer',
      updateCustomerDocumentStatus: 'customer/updateCustomerDocumentStatus',
    }),
    loadDocument() {
      if (!this.document.file.uuid) return
      this.loading = true
      this.documentBase64 = null
      this.getArrayBuffer(this.document.file.uuid)
        .then((response) => {
          this.documentBase64 = arrayBufferToBase64(response.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    submit() {
      this.$confirm('', {
        title:
          this.status === 'CONFIRMED'
            ? `Schválit ${this.document.type.text.toLowerCase()}`
            : `Zamítnout ${this.document.type.text.toLowerCase()}`,
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.accepting = this.status === 'CONFIRMED'
          this.rejecting = this.status === 'REJECTED'
          this.updateCustomerDocumentStatus({
            id: this.$route.params.customerId,
            documentId: this.document.id,
            status: this.status,
            statusMessage: this.statusMessage,
          }).finally(() => {
            this.accepting = false
            this.rejecting = false
            this.$refs.customerDocumentForm.reset()
            this.$emit('customerDocumentComplete', this.status === 'CONFIRMED')
            this.close()
          })
        }
      })
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
